


(function() {
  function waitForLibraries(callback) {
    if (typeof algoliasearch !== 'undefined' && typeof autocomplete !== 'undefined') {
      callback();
    } else {
      setTimeout(() => waitForLibraries(callback), 50);
    }
  }

  waitForLibraries(() => {
    console.log('Algolia libraries loaded, initializing autocomplete');

const searchClient = algoliasearch(
  'OKL660GSM6',
  'cd78f7853c712707fdf3399ab84c16f2'
);
    const index = searchClient.initIndex('palyset_shopify_products');

    const input = document.querySelector('#Search-In-Modal');
    if (!input) return;

    // Remove any existing autocomplete container (default Algolia)
    const existing = input.parentElement.querySelector('.aa-Autocomplete');
    if (existing) existing.remove();

    autocomplete({
      container: input,
      placeholder: 'Sök produkter',
      openOnFocus: true
    }, [
      {
        sourceId: 'products',
        getItems({ query }) {
          if (!query) return [];
          return index.search(query, { hitsPerPage: 5 }).then(r => r.hits);
        },
        templates: {
          item({ item, html }) {
            return html`
              <a href="${item.url}" class="aa-ItemLink">
                <div>
                  <strong>${item.title}</strong><br>
                  <span>${formatPrice(item.price_min)}</span>
                </div>
              </a>
            `;
          }
        }
      }
    ]);

    function formatPrice(cents) {
      return new Intl.NumberFormat('sv-SE', { style: 'currency', currency: 'SEK' }).format(cents / 100);
    }
  });
})();
